module.exports = __webpack_public_path__ + "static/media/craft_start_first.947a9487.mp3";